const EVENT_LABEL_SUFFIX = ' · ';

/** Synthetic labels from the legacy aggregated journey (still translated for old payloads). */
export const ROOT_EVENT_NAME = 'Session Start';
export const JOURNEY_END_LABEL = 'Path ended';

export const getAnalyticsEventBaseName = (eventName: string): string => {
  const separatorIndex = eventName.indexOf(EVENT_LABEL_SUFFIX);

  if (separatorIndex === -1) {
    return eventName.trim();
  }

  return eventName.slice(0, separatorIndex).trim();
};

export const getAnalyticsEventContextSuffix = (eventName: string): string | null => {
  const separatorIndex = eventName.indexOf(EVENT_LABEL_SUFFIX);

  if (separatorIndex === -1) {
    return null;
  }

  const suffix = eventName.slice(separatorIndex + EVENT_LABEL_SUFFIX.length).trim();

  return suffix.length > 0 ? suffix : null;
};

export const eventNameToTranslationKey = (eventName: string): string =>
  getAnalyticsEventBaseName(eventName)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
